import type { HelperResult, Address, AddressMutation, AddressType } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import type { UseFindFilters } from '../../utils/services/getUseFind';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useFind: useFindAddresses,
  useUpdate: useUpdateAddress,
  useDelete: useDeleteAddress,
} = getCRUDHooks({
  entityName: 'address',
  find: ({
    userId,
    filters,
  }: {
    userId: number;
    filters?: UseFindFilters<{ type: AddressType }>;
  }): HelperResult<Address[]> =>
    clientApi.getOCClient().helpers.user.users.id(userId).addresses.find(filters),
  update: (
    values: Partial<AddressMutation>,
    { userId, addressType, context }: { userId: number; addressType: AddressType; context: string }
  ): HelperResult<Address> =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .addresses.update(addressType, values, false)
      .setHeader('X-Request-Context', context)
      .execute(),
  remove: ({ userId, addressType }: { userId: number; addressType: AddressType }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).addresses.id(addressType).delete(),
});

export { useFindAddresses, useUpdateAddress, useDeleteAddress };
